import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import YouTube from './YouTube';
import ClientProvider from './client';
export default createDemo(import.meta.url, YouTube, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/skeleton/demos/you-tube/YouTube.tsx",
    "fileName": "YouTube.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Grid from '@mui/material/Grid';\nimport Box from '@mui/material/Box';\nimport Typography from '@mui/material/Typography';\nimport Skeleton from '@mui/material/Skeleton';\n\nconst data = [\n  {\n    src: 'https://i.ytimg.com/vi/pLqipJNItIo/hqdefault.jpg?sqp=-oaymwEYCNIBEHZIVfKriqkDCwgBFQAAiEIYAXAB&rs=AOn4CLBkklsyaw9FxDmMKapyBYCn9tbPNQ',\n    title: 'Don Diablo @ Tomorrowland Main Stage 2019 | Official…',\n    channel: 'Don Diablo',\n    views: '396k views',\n    createdAt: 'a week ago',\n  },\n  {\n    src: 'https://i.ytimg.com/vi/_Uu12zY01ts/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCpX6Jan2rxrCAZxJYDXppTP4MoQA',\n    title: 'Queen - Greatest Hits',\n    channel: 'Queen Official',\n    views: '40M views',\n    createdAt: '3 years ago',\n  },\n  {\n    src: 'https://i.ytimg.com/vi/kkLk2XWMBf8/hqdefault.jpg?sqp=-oaymwEYCNIBEHZIVfKriqkDCwgBFQAAiEIYAXAB&rs=AOn4CLB4GZTFu1Ju2EPPPXnhMZtFVvYBaw',\n    title: 'Calvin Harris, Sam Smith - Promises (Official Video)',\n    channel: 'Calvin Harris',\n    views: '130M views',\n    createdAt: '10 months ago',\n  },\n];\n\ninterface MediaProps {\n  loading?: boolean;\n}\n\nfunction Media(props: MediaProps) {\n  const { loading = false } = props;\n\n  return (\n    <Grid container wrap=\"nowrap\">\n      {(loading ? Array.from(new Array(3)) : data).map((item, index) => (\n        <Box key={index} sx={{ width: 210, marginRight: 0.5, my: 5 }}>\n          {item ? (\n            <img\n              style={{ width: 210, height: 118 }}\n              alt={item.title}\n              src={item.src}\n            />\n          ) : (\n            <Skeleton variant=\"rectangular\" width={210} height={118} />\n          )}\n          {item ? (\n            <Box sx={{ pr: 2 }}>\n              <Typography gutterBottom variant=\"body2\">\n                {item.title}\n              </Typography>\n              <Typography\n                variant=\"caption\"\n                sx={{ display: 'block', color: 'text.secondary' }}\n              >\n                {item.channel}\n              </Typography>\n              <Typography variant=\"caption\" sx={{ color: 'text.secondary' }}>\n                {`${item.views} • ${item.createdAt}`}\n              </Typography>\n            </Box>\n          ) : (\n            <Box sx={{ pt: 0.5 }}>\n              <Skeleton />\n              <Skeleton width=\"60%\" />\n            </Box>\n          )}\n        </Box>\n      ))}\n    </Grid>\n  );\n}\n\nexport default function YouTube() {\n  return (\n    <Box sx={{ overflow: 'hidden' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Media loading />\n      <Media />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 84,
        "focusedLines": 2,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Grid from '@mui/material/Grid';\nimport Box from '@mui/material/Box';\nimport Typography from '@mui/material/Typography';\nimport Skeleton from '@mui/material/Skeleton';\n\nconst data = [\n  {\n    src: 'https://i.ytimg.com/vi/pLqipJNItIo/hqdefault.jpg?sqp=-oaymwEYCNIBEHZIVfKriqkDCwgBFQAAiEIYAXAB&rs=AOn4CLBkklsyaw9FxDmMKapyBYCn9tbPNQ',\n    title: 'Don Diablo @ Tomorrowland Main Stage 2019 | Official…',\n    channel: 'Don Diablo',\n    views: '396k views',\n    createdAt: 'a week ago',\n  },\n  {\n    src: 'https://i.ytimg.com/vi/_Uu12zY01ts/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCpX6Jan2rxrCAZxJYDXppTP4MoQA',\n    title: 'Queen - Greatest Hits',\n    channel: 'Queen Official',\n    views: '40M views',\n    createdAt: '3 years ago',\n  },\n  {\n    src: 'https://i.ytimg.com/vi/kkLk2XWMBf8/hqdefault.jpg?sqp=-oaymwEYCNIBEHZIVfKriqkDCwgBFQAAiEIYAXAB&rs=AOn4CLB4GZTFu1Ju2EPPPXnhMZtFVvYBaw',\n    title: 'Calvin Harris, Sam Smith - Promises (Official Video)',\n    channel: 'Calvin Harris',\n    views: '130M views',\n    createdAt: '10 months ago',\n  },\n];\n\ninterface MediaProps {\n  loading?: boolean;\n}\n\nfunction Media(props: MediaProps) {\n  const { loading = false } = props;\n\n  return (\n    <Grid container wrap=\"nowrap\">\n      {(loading ? Array.from(new Array(3)) : data).map((item, index) => (\n        <Box key={index} sx={{ width: 210, marginRight: 0.5, my: 5 }}>\n          {item ? (\n            <img\n              style={{ width: 210, height: 118 }}\n              alt={item.title}\n              src={item.src}\n            />\n          ) : (\n            <Skeleton variant=\"rectangular\" width={210} height={118} />\n          )}\n          {item ? (\n            <Box sx={{ pr: 2 }}>\n              <Typography gutterBottom variant=\"body2\">\n                {item.title}\n              </Typography>\n              <Typography\n                variant=\"caption\"\n                sx={{ display: 'block', color: 'text.secondary' }}\n              >\n                {item.channel}\n              </Typography>\n              <Typography variant=\"caption\" sx={{ color: 'text.secondary' }}>\n                {`${item.views} • ${item.createdAt}`}\n              </Typography>\n            </Box>\n          ) : (\n            <Box sx={{ pt: 0.5 }}>\n              <Skeleton />\n              <Skeleton width=\"60%\" />\n            </Box>\n          )}\n        </Box>\n      ))}\n    </Grid>\n  );\n}\n\nexport default function YouTube() {\n  return (\n    <Box sx={{ overflow: 'hidden' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Media loading />\n      <Media />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 80
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Media"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "loading"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 81
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Media"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 84,
    "focusedLines": 2,
    "collapsible": true,
    "externals": [
      "@mui/material/Grid",
      "@mui/material/Box",
      "@mui/material/Typography",
      "@mui/material/Skeleton"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
